/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cozy_Ago_Felix_AdoreInputs */

const fr_cozy_ago_felix_adore = /** @type {(inputs: Cozy_Ago_Felix_AdoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il ne te reste plus beaucoup de séances, n'hésites pas à voir un coach afin de faire le plein.`)
};

/**

* @param {Cozy_Ago_Felix_AdoreInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const cozy_ago_felix_adore = /** @type {((inputs?: Cozy_Ago_Felix_AdoreInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cozy_Ago_Felix_AdoreInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_cozy_ago_felix_adore(inputs)
});